import { useCallback, useState } from 'react';

export const usePromptInputDialog = () => {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => {
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isOpen: open,
    openDialog,
    closeDialog,
  };
};
